export default __webpack_public_path__ + "media/images/front/about/departure-12e48f3c7b88fecb3fc879955ed2e4a6.png";